import { render, staticRenderFns } from "./Ejercido.vue?vue&type=template&id=5a856855"
import script from "./Ejercido.vue?vue&type=script&lang=js"
export * from "./Ejercido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports